import PropTypes from 'prop-types';

export const storeType = PropTypes.shape({
  address: PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string,
    county: PropTypes.string,
    state: PropTypes.string,
    street: PropTypes.string,
    zipcode: PropTypes.string,
  }),
  name: PropTypes.string,
  phone: PropTypes.string,
  storeId: PropTypes.string,
  distance: PropTypes.number,
});